import React from "react";
import "./homecover.scss";
import banner2 from "../../../../../assets/images/banner2.jpg";
import Button from "react-bootstrap/Button";
import homecover from "../../S_Sections/assets/images/home_cover_dwarve.png";

const Homecover = () => {
  return (
    <>
      <div className="homecover_section">
        <div className="homecover">
          <div className="homecoverleft">
            <div className="home_cover_heading">
              <h4>WELCOME TO THE MINES</h4>
            </div>
            <div className="home_cover_para">
              <h1>A COMMUNITY DRIVEN NFT PROJECT </h1>
              <h1>DELIVERING PASSIVE INCOME </h1>
              <h1>THROUGH OUR $ORE.</h1>
            </div>

            <div className="homebtns">
              <div className="hbtn">
                <div className="hbtn1">
                  <h6 style={{ color: "#56c7fc" }}>$ORE-</h6>
                  <p>TBD</p>
                </div>
                <div className="hbtn2">
                  <h6 style={{ color: "#56c7fc" }}>STAKERS-</h6>
                  <p>TBD</p>
                </div>
                <div className="hbtn3">
                  <h6 style={{ color: "#56c7fc" }}>STAKED%</h6>
                  <p>TBD</p>
                </div>
                <div className="hbtn4">
                  <a
                    href="https://discord.com/invite/QTsHxHtj9k"
                    target="_blank"
                  >
                    <Button>Join Discord</Button>
                  </a>
                </div>
              </div>
              <div className="hbtn5">
                <a href="https://discord.com/invite/QTsHxHtj9k" target="_blank">
                  <Button>Join Discord</Button>
                </a>
              </div>
            </div>
            {/* team_section .hbtn5 

                        team_section .hbtn5 
                        team_section .hbtn5  */}
          </div>
          <div className="homecoverright">
            {/* <img src={homecover} alt="" /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Homecover;
